<template>
  <v-footer app>
    <span>© {{ new Date().getFullYear() }}</span>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>